import React from 'react';
import '../assents/styles/components/Contact.scss';

function Contact() {
  return (
    <div className="contact-container">
      <h2>Contact Me</h2>
      <p>Let’s connect and collaborate on your next project!</p>

      <div className="contact-info">
        <p><strong>Full Name:</strong> Denis Eduardo Sánchez Ballén</p>
        <p><strong>Location:</strong> Bogotá, Colombia</p>
        <p><strong>Phone:</strong> (+57) 320 580 0647</p>
        <p><strong>Email:</strong> <a href="mailto:contact.denis.sanchez@gmail.com">contact.denis.sanchez@gmail.com</a></p>
        <p><strong>GitHub:</strong> <a href="https://github.com/DenisV2112" target="_blank" rel="noreferrer">github.com/DenisV2112</a></p>
        <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/denisanchez/" target="_blank" rel="noreferrer">linkedin.com/in/denisanchez</a></p>
        <p><strong>Codewars:</strong> <a href="https://www.codewars.com/users/DenisV2103" target="_blank" rel="noreferrer">codewars.com/users/DenisV2103</a></p>
      </div>

      <div className="skills">
        <h3>Key Skills</h3>
        <ul>
          <li>React.js</li>
          <li>JavaScript ES5/ES6</li>
          <li>HTML5 / CSS3 / SASS / Bootstrap</li>
          <li>ASP.NET (C#)</li>
          <li>SQL Server</li>
          <li>REST APIs</li>
          <li>Git / GitHub / Bitbucket</li>
          <li>Docker</li>
          <li>Google Cloud</li>
          <li>Agile (Jira)</li>
        </ul>
      </div>
    </div>
  );
}

export default Contact;
